// Import React dependencies.
import React, { useEffect, Dispatch, SetStateAction } from 'react';
import classNames from 'classnames';
import { ImageAdd } from '@styled-icons/boxicons-regular';
import Image from 'next/legacy/image';
import styles from './UploadImage.module.css';

function UploadImage({
  file,
  setfile,
  width,
  height,
  borderRadius,
  placeholderImage,
  containerWidth,
  containerHeight,
  className,
  disabled,
  onRemoveCard,
}: {
  file: File;
  setfile: Dispatch<SetStateAction<File>>;
  width: number;
  height: number | string;
  borderRadius: number;
  placeholderImage: string;
  containerWidth?: number;
  containerHeight?: number | string;
  className?: string;
  disabled?: boolean;
  onRemoveCard?: () => void;
}) {
  const uploadedImage = React.useRef(null);
  const imageUploader = React.useRef(null);

  useEffect(() => {
    if (!file) {
      const { current } = uploadedImage;
      current.src = placeholderImage;
      const imageUploaderRef = imageUploader?.current;
      imageUploaderRef.value = null;
    }
  }, [file]);

  const handleChange = (e: any) => {
    if (e.target.files) {
      const uploadedFile = e.target.files[0];
      setfile(uploadedFile);
      const reader = new FileReader();
      const { current } = uploadedImage;
      current.file = uploadedFile;
      reader.onload = (ev) => {
        current.src = ev.target.result;
      };
      if (uploadedFile) {
        reader.readAsDataURL(uploadedFile);
      }
    }
  };

  return (
    <div>
      <div className={styles.deleteButton} style={{ width: containerWidth + 5 }}>
        <Image src="/images/x-circle.svg" width={20} height={20} onClick={onRemoveCard} />
      </div>
      <div
        className={classNames(styles.container, className)}
        style={{
          width: containerWidth || width,
          height: containerHeight || height,
          borderRadius,
        }}
      >
        <input
          type="file"
          accept="image/*"
          multiple={false}
          onChange={handleChange}
          ref={imageUploader}
          style={{
            display: 'none',
          }}
          disabled={disabled}
        />
        <img
          src={placeholderImage}
          ref={uploadedImage}
          width={width}
          height={height}
          alt="Preview"
          style={{
            width,
            height,
            borderRadius,
            opacity: disabled ? 0.4 : 1,
            objectFit: 'contain',
          }}
          role="none"
          onClick={disabled ? () => null : () => imageUploader.current.click()}
        />
        {!disabled && (
          <div
            className={styles.overlay}
            role="none"
            onClick={disabled ? () => null : () => imageUploader.current.click()}
          >
            <ImageAdd size={20} className="has-text-white" />
          </div>
        )}
      </div>
    </div>
  );
}

UploadImage.defaultProps = {
  containerWidth: undefined,
  containerHeight: undefined,
  className: undefined,
  disabled: false,
  onRemoveCard: null,
};

export default UploadImage;
